import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from '../../../../components/Button';

interface ButtonsProps {
  loading: boolean;
  view: boolean;
  external?: boolean;
  onSubmit: (e?: React.FormEvent) => void;
  onCancel: () => void;
}

const Buttons: React.FC<ButtonsProps> = ({
  loading,
  view,
  external,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(!external && "p-4")}>
      {
        !view && (
          <Button
            className="btn btn-primary me-3"
            text={t("reservations.edit.pageTexts.form.buttons.save")}
            disabled={loading}
            loading={loading}
            onClick={onSubmit}
          />
        )
      }
      <Button className="btn btn-outline-secondary" text={t("reservations.edit.pageTexts.form.buttons.cancel")} onClick={onCancel} />
    </div>
  );
};

export default Buttons;
